// SCR-002: sign in, signing in, no access, signed out, issuer unreachable. A centred card with the
// Nexus mark; the sign-in control is a plain link to the BFF's /auth/login (a top-level
// navigation, so the redirect chain happens outside the page and no token ever reaches script).
import { useContext, useState } from "preact/hooks";
import { SessionContext } from "../../session/session";
import { Lockup, LogoMark } from "../../ui/logo";
import { signInStateFrom, signInView, startSigningIn } from "./model";

// Staff sign in through AllCode's AWS IAM Identity Center (SAML); the page names it plainly.
const ISSUER_NAME = "AWS IAM Identity Center";

export function SignIn({ query }: { params: Record<string, string>; query: URLSearchParams }) {
  const services = useContext(SessionContext);
  const noAccess = services?.state.status === "no-access" ? { who: services.state.who } : null;
  const [state, setState] = useState(() => signInStateFrom(query, noAccess));
  const view = signInView(state, ISSUER_NAME);

  return (
    <main class="signin">
      <section class={`card signin-card tone-${view.tone}`} aria-labelledby="signin-heading">
        <div class="signin-brand">
          <LogoMark class="signin-mark" />
          <p class="wordmark">
            <Lockup size="lg" />
          </p>
        </div>
        <h1 id="signin-heading">{view.heading}</h1>
        {view.message && (
          <p role={view.tone === "error" ? "alert" : view.tone === "warning" ? "status" : undefined} class="signin-message">
            {view.message}
          </p>
        )}
        {(view.signIn || (view.signOut && services)) && (
          <div class="signin-actions">
            {view.signIn && (
              <a
                class="button button-primary signin-button"
                href={view.signIn.href}
                aria-disabled={view.signIn.busy ? "true" : undefined}
                onClick={(event) => {
                  if (view.signIn?.busy) event.preventDefault();
                  else setState(startSigningIn(state));
                }}
              >
                {view.signIn.busy && <span class="spinner" aria-hidden="true" />}
                {view.signIn.label}
              </a>
            )}
            {view.signOut && services && (
              <button type="button" class="button button-secondary signin-button" onClick={() => void services.signOut()}>
                Sign out
              </button>
            )}
          </div>
        )}
        <p class="signin-foot">
          Access is granted by your group in {ISSUER_NAME}. If you need a role, ask a Nexus super-admin.
        </p>
      </section>
    </main>
  );
}
